var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "flex-column flex-fill",
        class: [_vm.isFeatureMode ? "d-none" : "d-flex"],
      },
      [
        _c(
          "div",
          {
            staticClass:
              "annotations-item panel-control-content d-flex flex-column flex-fill",
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn-toolbar w-100 justify-content-center",
                    attrs: { role: "toolbar", "aria-label": "" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btn-group btn-block",
                        attrs: { role: "group", "aria-label": "Actions" },
                      },
                      _vm._l(_vm.activeActions, function (action, key) {
                        return _c(
                          "button",
                          {
                            key: key,
                            staticClass: "btn btn-main min-w-auto mx-0",
                            class: {
                              "d-flex align-items-center justify-content-center":
                                !!action.image,
                            },
                            attrs: {
                              disabled: action.disabled(),
                              title: action.title,
                              type: "button",
                              "data-toggle": "tooltip-city",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.applyAction(key, $event)
                              },
                            },
                          },
                          [
                            action.icon
                              ? [_c("i", { class: action.icon })]
                              : action.image
                              ? [
                                  _c("img", {
                                    staticClass: "btn-image",
                                    attrs: { src: action.image },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row flex-fill" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "form",
                  { attrs: { autocomplete: "off", "data-vv-scope": "form" } },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "MaterialInput",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              staticClass: "city-form-group city-bg",
                              attrs: {
                                disabled: _vm.readonlyFormItem,
                                readonly: _vm.editing || _vm.readonlyFormItem,
                                type: "text",
                                id: "input-title",
                                name: "title",
                                inputClasses: [
                                  { "is-invalid": _vm.fnHasError("title") },
                                ],
                                error: _vm.fnFirstError("title"),
                              },
                              model: {
                                value: _vm.form.title,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "title",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.title",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    Título\n                                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "MaterialTextarea",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "",
                                  expression: "''",
                                },
                              ],
                              staticClass: "city-form-group city-bg mb-md-0",
                              attrs: {
                                readonly: _vm.readonlyFormItem,
                                disabled: _vm.editing || _vm.readonlyFormItem,
                                id: "input-description",
                                name: "description",
                                rows: 3,
                                inputClasses: [
                                  {
                                    "is-invalid": _vm.fnHasError("description"),
                                  },
                                ],
                                error: _vm.fnFirstError("description"),
                              },
                              model: {
                                value: _vm.form.description,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "description",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.description",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    Descrição\n                                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row geometries mt-3" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("hr", { staticClass: "my-2" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "row geometries-actions" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex flex-nowrap align-items-center justify-content-between",
                            },
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _c("div", {}, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-toolbar",
                                    attrs: {
                                      role: "toolbar",
                                      "aria-label": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "btn-group",
                                        attrs: {
                                          role: "group",
                                          "aria-label": "Geometries Actions",
                                        },
                                      },
                                      _vm._l(
                                        _vm.activeDrawControls,
                                        function (action, idx) {
                                          return _c(
                                            "button",
                                            {
                                              key: idx,
                                              staticClass: "btn min-w-auto",
                                              class: {
                                                active:
                                                  _vm.drawType === action.type,
                                              },
                                              attrs: {
                                                disabled: _vm.editing,
                                                title: action.title,
                                                type: "button",
                                                "data-toggle": "tooltip-city",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.setMapInteraction(
                                                    action
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              action.icon
                                                ? [
                                                    _c("i", {
                                                      class: action.icon,
                                                    }),
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              action.img
                                                ? [
                                                    _c("img", {
                                                      attrs: {
                                                        src: action.img,
                                                        alt: "Tool",
                                                      },
                                                    }),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row geometries-list" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.recordFeatures,
                                expression: "recordFeatures",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: { type: "hidden", name: "geometries" },
                            domProps: { value: _vm.recordFeatures },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.recordFeatures = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.fnHasError("geometries")
                            ? _c(
                                "div",
                                { staticClass: "city-form-group mb-0 col-12" },
                                [
                                  _c(
                                    "small",
                                    { staticClass: "invalid-feedback d-block" },
                                    [_vm._v(_vm._s(_vm.txtNoValidGeometries))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-12 pt-3",
                              class: { "text-center": !_vm.recordHasFeatures },
                            },
                            [
                              _vm.recordHasFeatures
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "row no-gutters" },
                                      [
                                        _vm._l(
                                          _vm.recordFeatures,
                                          function (feature, idx) {
                                            return [
                                              _c("record-item-feature", {
                                                key: `feature-${idx}`,
                                                attrs: {
                                                  feature: feature,
                                                  disabled: _vm.editing,
                                                  controlsConfig:
                                                    _vm.activeDrawControls,
                                                  moduleCode: _vm.moduleCode,
                                                  map: _vm.map,
                                                  readonlyFormItem:
                                                    _vm.readonlyFormItem,
                                                },
                                                on: {
                                                  geometryHighlight:
                                                    _vm.onGeometryHighlight,
                                                  selectedFeature:
                                                    _vm.onSelectedFeature,
                                                  zoomToFeature:
                                                    _vm.onZoomToFeature,
                                                  removeFeature:
                                                    _vm.onRemoveFeature,
                                                },
                                              }),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                : [
                                    _c("span", { staticClass: "small" }, [
                                      _vm._v(_vm._s(_vm.txtNoGeometries)),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.isFeatureMode
      ? _c(
          "div",
          { staticClass: "panel-control d-flex flex-column flex-fill" },
          [
            _c(
              "div",
              {
                staticClass:
                  "panel-control-content d-flex flex-column flex-fill",
              },
              [
                _c("record-item-feature-form", {
                  attrs: {
                    feature: _vm.selectedFeature,
                    controlsConfig: _vm.activeDrawControls,
                    moduleCode: _vm.moduleCode,
                    readonlyFormItem: _vm.readonlyFormItem,
                  },
                  on: { save: _vm.onSaveFeature, back: _vm.onBackFeature },
                }),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", {}, [
      _c("span", { staticClass: "subtitle" }, [_vm._v("Geometrias")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }